export class Unsafe {
  static fixTooltip(tt: any) {
    if (tt._tooltipInstance) {
      tt._tooltipInstance._handleBodyInteraction = () => {};
    }
  }
}
